// ======================================================
// TABS (BISON) - Product details tabs (Features / Specs / Size / Reviews)
// ======================================================

function getTabsBisonScrollOffset(section) {
  var header = document.querySelector('.header-bison');
  var headerH = header ? header.getBoundingClientRect().height : 0;
  var extra = 16;
  if (section) {
    var parsed = parseInt(section.getAttribute('data-reviews-scroll-offset'), 10);
    if (!isNaN(parsed)) extra = parsed;
  }
  return headerH + extra;
}

function scrollTabsBisonIntoView(section, targetEl) {
  var el = targetEl || section.querySelector('.feature-tabs') || section;
  if (!el) return;
  var top = el.getBoundingClientRect().top + window.pageYOffset - getTabsBisonScrollOffset(section);
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

function getTabsBisonReviewsTabId(section) {
  var btn = section.querySelector('.feature-tabs .nav-link[data-tab$="-reviews"]');
  return btn ? btn.getAttribute('data-tab') : null;
}

function getTabsBisonReviewsScrollTarget(section) {
  if (!section) return null;
  var selector = (section.getAttribute('data-reviews-scroll-target') || '').trim();
  if (!selector) return null;
  try {
    return document.querySelector(selector);
  } catch (err) {
    console.warn('[Tabs Bison] Invalid reviews scroll target selector:', selector);
    return null;
  }
}

function shouldScrollReviewsTab(section) {
  return section && section.getAttribute('data-reviews-tab-action') === 'scroll_to_section';
}

function scrollToTabsBisonReviewsTarget(section) {
  var target = getTabsBisonReviewsScrollTarget(section);
  if (!target) return false;
  scrollTabsBisonIntoView(section, target);
  return true;
}

function findTabsBisonReviewsSection() {
  var sections = document.querySelectorAll('.tabs-bison');
  var fallback = null;

  for (var i = 0; i < sections.length; i += 1) {
    var section = sections[i];
    var reviewsApp = section.querySelector('[data-tabs-bison-reviews-app]');
    if (!reviewsApp) continue;
    if (!fallback) fallback = section;
    if (
      reviewsApp.querySelector('.tabs-bison-reviews-app__block') ||
      reviewsApp.querySelector('.jdgm-widget') ||
      reviewsApp.querySelector('.jdgm-rev-widg')
    ) {
      return section;
    }
  }

  return fallback || document.querySelector('.tabs-bison');
}

window.BisonTabsBison = window.BisonTabsBison || {};

window.BisonTabsBison.openReviewsTab = function(options) {
  options = options || {};
  var section = findTabsBisonReviewsSection();
  if (!section) return false;

  if (shouldScrollReviewsTab(section)) {
    var scrolled = scrollToTabsBisonReviewsTarget(section);
    if (scrolled) return true;
  }

  var tabId = getTabsBisonReviewsTabId(section);
  if (!tabId) return false;

  if (typeof section._bisonTabsActivate === 'function') {
    section._bisonTabsActivate(tabId);
  } else {
    var reviewBtn = section.querySelector('.feature-tabs .nav-link[data-tab$="-reviews"]');
    if (reviewBtn) reviewBtn.click();
  }

  if (options.scroll !== false) {
    window.setTimeout(function() {
      scrollTabsBisonIntoView(section);
    }, 60);
  }

  return true;
};

function initTabsBisonSection(section) {
  var tabs = section.querySelectorAll('.feature-tabs .nav-link');
  var contents = section.querySelectorAll('.tab-content');
  var floatTrack = section.querySelector('[data-float-rec-track]');
  var floatItems = floatTrack ? floatTrack.querySelectorAll('[data-float-rec-item]') : [];
  var floatPrev = section.querySelector('[data-float-rec-arrow="prev"]');
  var floatNext = section.querySelector('[data-float-rec-arrow="next"]');
  var floatIndex = 0;

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: Number(variantId),
        quantity: Math.max(1, Number(quantity) || 1),
      }),
    }).then(function(res) {
      if (!res.ok) throw new Error('Failed to add recommended product');
      return res.json();
    });
  }

  function updateFloatTrack() {
    if (!floatTrack || !floatItems.length) return;
    var maxIndex = Math.max(floatItems.length - 1, 0);
    if (floatIndex < 0) floatIndex = 0;
    if (floatIndex > maxIndex) floatIndex = maxIndex;
    var itemWidth = floatItems[0].getBoundingClientRect().width;
    var gap = 12; // Matches CSS gap of 0.75rem.
    var offset = floatIndex * (itemWidth + gap);
    floatTrack.style.transform = 'translateX(-' + offset + 'px)';
    if (floatPrev) floatPrev.disabled = floatIndex <= 0;
    if (floatNext) floatNext.disabled = floatIndex >= maxIndex;
  }

  if (floatTrack && floatItems.length > 1) {
    if (floatPrev) {
      floatPrev.addEventListener('click', function() {
        floatIndex -= 1;
        updateFloatTrack();
      });
    }
    if (floatNext) {
      floatNext.addEventListener('click', function() {
        floatIndex += 1;
        updateFloatTrack();
      });
    }
    window.addEventListener('resize', updateFloatTrack);
    updateFloatTrack();
  } else if (floatPrev && floatNext) {
    floatPrev.disabled = true;
    floatNext.disabled = true;
  }

  function isMobileAccordion() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  function deactivateAllTabs() {
    section.querySelectorAll('.tabs-bison-tab-entry').forEach(function(entry) {
      entry.classList.remove('is-active');
    });
    tabs.forEach(function(tab) {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    contents.forEach(function(panel) {
      panel.classList.remove('active');
    });
  }

  function activateTab(tabId) {
    if (!tabId) return;
    section.querySelectorAll('.tabs-bison-tab-entry').forEach(function(entry) {
      var isActive = entry.getAttribute('data-bison-tab-entry') === tabId;
      entry.classList.toggle('is-active', isActive);
    });
    tabs.forEach(function(tab) {
      var isSelected = tab.getAttribute('data-tab') === tabId;
      tab.classList.toggle('active', isSelected);
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
    contents.forEach(function(panel) {
      var isActive = panel.getAttribute('data-bison-tab') === tabId;
      panel.classList.toggle('active', isActive);
    });
    if (tabId && tabId.indexOf('-reviews') !== -1) {
      window.setTimeout(function() {
        window.dispatchEvent(new Event('resize'));
      }, 80);
    }
  }

  if (tabs.length && contents.length) {
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        var tabId = this.getAttribute('data-tab');
        var entry = this.closest('.tabs-bison-tab-entry');

        if (tabId && tabId.indexOf('-reviews') !== -1 && shouldScrollReviewsTab(section)) {
          var scrolled = scrollToTabsBisonReviewsTarget(section);
          if (scrolled) return;
        }

        if (isMobileAccordion() && entry && entry.classList.contains('is-active')) {
          deactivateAllTabs();
          return;
        }
        activateTab(tabId);
      });
    });
  }

  if (!section.dataset.floatRecAddBound) {
    section.dataset.floatRecAddBound = '1';
    section.addEventListener('click', function(event) {
      var addBtn = event.target.closest('[data-float-rec-add]');
      if (!addBtn) return;
      event.preventDefault();

      var variantId = addBtn.getAttribute('data-float-rec-variant-id');
      var quantity = addBtn.getAttribute('data-float-rec-quantity') || '1';
      if (!variantId) return;

      var originalLabel = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      addBtn.textContent = 'Adding...';
      addToCart(variantId, quantity)
        .then(function() {
          if (window.BisonStaticCartDrawer && typeof window.BisonStaticCartDrawer.open === 'function') {
            window.BisonStaticCartDrawer.open();
            return;
          }
          if (window.location && window.location.pathname !== '/cart') {
            // Fallback for stores where static drawer is not mounted.
            window.location.href = '/cart';
          }
        })
        .catch(function(error) {
          console.error(error);
        })
        .finally(function() {
          addBtn.textContent = originalLabel;
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
        });
    });
  }

  section._bisonTabsActivate = activateTab;
  section._bisonTabsReviewsTabId = getTabsBisonReviewsTabId(section);
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.tabs-bison').forEach(initTabsBisonSection);
});

function applyTabsBisonFeaturesContent(variantId) {
  if (!variantId || !window.productTabsBisonFeatures) return;
  var variantKey = String(variantId);

  document.querySelectorAll('.tabs-bison[data-bison-variant-features]').forEach(function(section) {
    var sectionId = section.dataset.sectionId;
    if (!sectionId) return;
    var data = window.productTabsBisonFeatures[sectionId];
    if (!data) return;

    var variantHtml = data.variants && data.variants[variantKey];
    var html = variantHtml && String(variantHtml).trim() ? variantHtml : data.fallback || '';

    section.querySelectorAll('[data-tabs-bison-features-content]').forEach(function(el) {
      el.innerHTML = html;
    });
  });
}

if (!window.__bisonTabsVariantFeaturesBound) {
  window.__bisonTabsVariantFeaturesBound = true;
  document.addEventListener('bison:variant-change', function(e) {
    var variantId = e.detail && e.detail.variantId;
    applyTabsBisonFeaturesContent(variantId);
  });
}

document.addEventListener('shopify:section:load', function(e) {
  var section = e.target.querySelector && e.target.querySelector('.tabs-bison');
  if (!section && e.target.classList && e.target.classList.contains('tabs-bison')) section = e.target;
  if (section) initTabsBisonSection(section);
});
